import { Stack, Typography } from '@mui/material';

import {
  Icon,
  Loading,
  SummaryCardNew,
} from '@hapvida/hapvida-core-components';

import {
  MOVEMENT_SUMMARY_ITEMS,
  BeneficiaryMovementTypeEnum,
} from '@constants';

import { StackContainer, StackItem } from './styles';
import { useMovementsMobileState } from '../../hooks/useMovementsMobileState';

export function MovementsSummaryCardMobile() {
  const { movementsSummaryState } = useMovementsMobileState();

  if (movementsSummaryState?.isLoading) {
    return (
      <SummaryCardNew.Container>
        <Loading minHeight={200} alignItems="center" justifyContent="center" />
      </SummaryCardNew.Container>
    );
  }

  if (movementsSummaryState.isError) {
    return null;
  }

  const summaryValues = movementsSummaryState.data.reduce(
    (acc, movementSummary) => {
      if (
        Object.values(BeneficiaryMovementTypeEnum).includes(
          movementSummary.code,
        )
      ) {
        acc[movementSummary.code] = movementSummary.count;
      }
      return acc;
    },
    {} as Record<BeneficiaryMovementTypeEnum, number>,
  );

  return (
    <StackContainer direction="row" gap={2}>
      {MOVEMENT_SUMMARY_ITEMS.map(item => (
        <StackItem key={item?.key} flexDirection="column">
          <Stack justifyContent="space-between" flexDirection="row">
            <Typography color={item?.color} fontWeight={900} variant="h5">
              {summaryValues[item.key] ?? '-'}
            </Typography>
            {item.iconName && (
              <Icon color={item?.color} name={item.iconName} size={32} />
            )}
          </Stack>
          <Typography color="#767C81" fontWeight={400} variant="text">
            {item?.label ?? '-'}
          </Typography>
        </StackItem>
      ))}
    </StackContainer>
  );
}
